module.exports = __webpack_public_path__ + "img/logo-agrovision.e4106787.svg";